module.exports = __webpack_public_path__ + "static/media/banco-de-bosques.e30e55a2.png";